module.exports = __webpack_public_path__ + "static/media/insigne.986f2825.jpg";